import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DateTypeEnum, ReservationListReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): ReservationListReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  company: null,
  rates: [],
  roomType: 0,
  with_revenue: false,
  currency: null,
  currency_application: null,
  fixed_at: '',
  date_type: DateTypeEnum.BOOKING_DATE,
  gross_revenue: false,
  file_type: 'pdf',
});
